var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    height: "48px",
    width: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.43,20.62H13.7c-0.14,0-0.26-0.11-0.26-0.24v-3.13c0-0.19-0.22-0.3-0.39-0.21L1.02,23.51 c-0.17,0.09-0.17,0.33,0,0.42l12.03,6.48c0.17,0.09,0.39-0.02,0.39-0.21v-3.13c0-0.13,0.12-0.24,0.26-0.24h7.74 c0.14,0,0.26-0.11,0.26-0.24v-5.73C21.69,20.72,21.58,20.62,21.43,20.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.68,20.62h7.74c0.14,0,0.26-0.11,0.26-0.24v-3.13c0-0.19,0.22-0.3,0.39-0.21l12.03,6.48 c0.17,0.09,0.17,0.33,0,0.42l-12.03,6.48c-0.17,0.09-0.39-0.02-0.39-0.21v-3.13c0-0.13-0.12-0.24-0.26-0.24h-7.74 c-0.14,0-0.26-0.11-0.26-0.24v-5.73C26.42,20.72,26.54,20.62,26.68,20.62z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg19);
export default __webpack_public_path__ + "static/media/19.20453c3eab7632723542990417221506.svg";
export { ForwardRef as ReactComponent };